import { Controller, Scene } from 'scrollmagic';
import { TimelineMax, TweenMax, Power4 } from 'gsap';

import { classes, isiE, DOM, events } from '../const';

import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

const { customCursorUpdate } = events;
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

const { isSticky, noScroll } = classes;
const { $window, $document } = DOM;

const scrollController = new Controller();

const $$sidescrollStages = $('.js-sidescroll-stage');
const $$applicationSteps = $('.js-application-steps');
const $$transitionGroups = $('.js-transition-group');
const $$textBoxImgs = $('.text-box__image img');
const $$counterStarter = $('.counter');
const $$backToTopButtons = $('.back-to-top');

$.fn.isInViewport = function () {
  const elementTop = $(this).offset().top;
  const elementBottom = elementTop + $(this).outerHeight();

  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

export const initTransitionGroup = $el => {

  let $$elems = null;

  if ($el.hasClass('js-transition-el')) {
    $$elems = $el;
  } else {
    $$elems = $el.find('.js-transition-el:not(.js-transition-group .js-transition-group .js-transition-el)');
  }


  const trigger = $el.data('trigger') ? $el.data('trigger') : 1;
  const reverse = !$el.data('one-direction');
  const startY = $el.data('anim-translate') !== undefined ? +$el.data('anim-translate') : 30;

  const animation = new TimelineMax()
    .fromTo($$elems, 1, { y: startY, opacity: 0 }, {
      y: 0, opacity: 1, onComplete() {
        $(document).trigger('imgAnimationEnd');
      }
    }, 0.25);

  const scene = new Scene({
    triggerElement: $el[0],
    triggerHook: trigger
  })

  scene
    .reverse(reverse)
    .setTween(animation)
    // .addIndicators()
    .addTo(scrollController);
};

const initApplicationSteps = el => {
  const $deskFlag = $(el).find('.js-desk-flag');
  const $scollSide = $(el).find('.js-steps-scroll-side');
  const $mobFlag = $(el).find('.js-mob-flag');

  const itemsNum = $scollSide.find('.js-app-step').length

  const duration = itemsNum * 10 / 2;

  const animation = new TimelineMax()
    .fromTo($mobFlag[0], 1, { y: '60vh' }, { y: 0 }, 'one')
    .fromTo($deskFlag[0], 1, { y: `30vh` }, { y: 0 }, 'one')
    .to($scollSide[0], 1, { y: `-100%` }, 'one');

  let scene = new Scene({
    triggerElement: el,
    triggerHook: 'onLeave',
    duration: `${duration}0%`
  });

  const minHeight = 100 + itemsNum * 10 / 2 * 10;

  scene
    .on('add', () => {
      if (document.documentMode) return;
      $(el).addClass(isSticky);

      $(el).parent().removeAttr('style');

      $(el).css({
        top: 0
      });

      $(el).parent().css({
        height: `${minHeight}vh`,
        paddingTop: 0,
        paddingBottom: 0
      });
    })
    .on('progress', () => {
      if (document.documentMode) return;


      $(el).parent().removeAttr('style');

      $(el).parent().css({
        height: `${minHeight}vh`,
        paddingTop: 0,
        paddingBottom: 0
      });
    })
    .setPin(el)
    .setTween(animation)
    // .addIndicators()
    .addTo(scrollController);

  const checkScene = () => {
    if (scene) {
      scene.destroy(true);
      scene = null;
      initApplicationSteps(el);
    }
    $window.off('resize', checkScene);
  };

  $window.on('resize', checkScene);
};

const initSidescrollStage = el => {

  const isSmall = $(el).hasClass('is-small');

  const $$items = $(el).find('.js-sidescroll-stage-item');

  if (isSmall) {
    $(el).removeClass(noScroll);
    let fitsViewport = true;
    $$items.each((i, item) => {
      if ($(item).height() > $window.height() - 60) {
        fitsViewport = false;
      }
    });
    if (!fitsViewport) {
      $(el).addClass(noScroll);
      $window.one('resize', () => {
        initSidescrollStage(el);
      });
      return;
    }
  }

  const container = $(el).find('.js-sidescroll-stage-container')[0];

  const $$bgs = $(el).find('.js-sidescroll-stage-bg');

  const $$texts = $(el).find('.js-sidescroll-stage-text');

  const $$imgs = $(el).find('.js-sidescroll-stage-bg img');

  const itemsNum = $$items.length;

  const width = $$items.first().outerWidth();

  let diff = 0;

  if (isSmall) {
    diff = $window.width() < 480 ? 100 : 75;
  } else {
    diff = $window.width() < 768 ? 100 : 75;
  }



  const transform = width * itemsNum / $(container).outerWidth() * 100 - diff;

  let scene = new Scene({
    triggerElement: el,
    triggerHook: 'onLeave',
    duration: `${itemsNum - 1}00%`
  });

  const minHeight = 100 + (itemsNum - 1) * 100;

  const duration = 0.1;
  const containerTween = TweenMax.fromTo(container, duration, { rotation: 0.01 }, { x: 0, rotation: 0.01, scaleX: 1.001, delay: 0.05, force3D: true, ease: Power4.easeOut });
  let bgTween = null;
  let imgsTween = null;
  let textTween = null;

  if (!isSmall) {
    bgTween = TweenMax.to($$bgs, duration, { x: 0, force3D: true, ease: Power4.easeOut });
    imgsTween = TweenMax.to($$imgs, duration, { x: `-25%`, force3D: true, ease: Power4.easeOut });
    textTween = TweenMax.to($$texts, duration, { x: 0, force3D: true, ease: Power4.easeOut });
  }


  scene
    .on('add', () => {
      if (isiE) return;
      const $wrapper = $(el).parent();
      $(el).addClass(isSticky);
      $wrapper.addClass(isSticky);


      $(el).parent().removeAttr('style');

      $(el).css({
        top: 0
      })

      $(el).parent().css({
        height: `${minHeight}vh`,
        paddingTop: 0,
        paddingBottom: 0
      });

    })
    .on('progress', event => {
      $document.trigger(customCursorUpdate);
      if (!containerTween.vars.css) return;

      const { progress } = event;

      containerTween.vars.css.x = `-${transform * progress}%`;
      containerTween.invalidate().restart();
      if (!isSmall) {
        bgTween.vars.css.x = `-${5 * progress}%`;
        bgTween.invalidate().restart();
        imgsTween.vars.css.x = `${-25 * (1 - progress)}%`;
        imgsTween.invalidate().restart();
        textTween.vars.css.x = `-${5 * progress}%`;
        textTween.invalidate().restart();
      }

      if (isiE) return;

      $(el).parent().removeAttr('style');

      $(el).parent().css({
        height: `${minHeight}vh`,
        paddingTop: 0,
        paddingBottom: 0
      });
    })
    .setPin(el)
    // .addIndicators()
    .addTo(scrollController);


  const checkScene = () => {
    if (scene) {
      scene.destroy(true);
      scene = null;
      initSidescrollStage(el);
    }
    $window.off('resize', checkScene);
  };

  $window.on('resize', checkScene);
};


const initTextBoxImgParallax = ($el) => {
  const $videoWrapper = $el.closest('.video');
  const $target = $videoWrapper.length ? $videoWrapper : $el


  const watchImg = () => {

    if ($window.width() < 992) {
      $target.css('transform', `translate(0,0)`);
      return;
    }

    const windowTop = $window.scrollTop();
    const windowHeight = $window.height();
    const elTop = $target.offset().top;
    const elHeight = $target.height();

    const range = 90;
    const percent = ((windowTop - elTop) / (windowHeight - elHeight)) * 100;

    if (percent < -100 || percent > 0) return;
    const translate = percent / 100 * range;
    $target.css('transform', `translate(0,${translate}px)`);
  };

  $el.on('load', watchImg);


  $(document).on('imgAnimationEnd', watchImg);
  $window.on('scroll', watchImg);
  $window.on('resize', watchImg);
};



const initCounterStarter = ($el) => {
  const element = $($el).find('.counter-number')
  const checkCoutner = () => {
    if (element.isInViewport()) {
      element.css('--num', element.attr('data-amount'))
    }
  }

  $window.on('scroll', checkCoutner);
  checkCoutner();
}

const initBackToTopButtons = ($el) => {
  let lastScrollPosition = 0;
  const checkVisibility = () => {
    const scrollPosition = $(window).scrollTop();
    if (scrollPosition > lastScrollPosition || scrollPosition < 100) {
      $el.fadeOut();
    }
    else {
      $el.fadeIn();
    }
    lastScrollPosition = scrollPosition;
  }

  $el.click(() => {
    $(window).scrollTop(0);
  })

  $window.on('scroll', checkVisibility);
  checkVisibility();
}

const scrollAnimations = () => {

  if (!isiE) {
    $$applicationSteps.each((i, el) => {
      initApplicationSteps(el);
    });
  }


  $$transitionGroups.each((i, el) => {
    initTransitionGroup($(el));
  });

  $$counterStarter.each((i, el) => {
    initCounterStarter($(el));
  });

  $$sidescrollStages.each((i, el) => {
    initSidescrollStage(el);
  });


  $$textBoxImgs.each((i, el) => {
    initTextBoxImgParallax($(el));
  });

  $$backToTopButtons.each((i, el) => {
    initBackToTopButtons($(el));
  });


};

export default scrollAnimations;
